import { useEffect, useState, useContext } from "react";
import Cta from "../cta/Cta";
import { SurveyContext } from "../../store/survey-context";
import { useTranslation } from "react-i18next";
export default function Filters(props) {
  const { t } = useTranslation("survey");
  const { macallanWhiskies } = useContext(SurveyContext);
  const collections = [
    ...new Set(macallanWhiskies.map((item) => item.collection)),
  ];
  //console.log(collections);
  useEffect(() => {
    //console.log(collections);
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const [tempMobileFilters, setTempMobileFilters] = useState(props.filters);
  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 767px)").matches
  );

  useEffect(() => {
    const mobileMediaQuery = window.matchMedia("(max-width: 767px)");
    const setMobileMediaQuery = () => {
      setIsMobile(mobileMediaQuery.matches);
    };

    try {
      mobileMediaQuery.addEventListener("change", setMobileMediaQuery);
    } catch {
      mobileMediaQuery.addListener(setMobileMediaQuery);
    }

    return () => {
      try {
        mobileMediaQuery.removeEventListener("change", setMobileMediaQuery);
      } catch {
        mobileMediaQuery.removeListener(setMobileMediaQuery);
      }
    };
  }, []);

  function onChange(e) {
    // on mobile filter values are temporary and need to be accepted either by "Apply" button or return arrow
    const value = e.nativeEvent.target.value;
    if (isMobile) {
      if (e.nativeEvent.target.checked) {
        setTempMobileFilters([...new Set(tempMobileFilters.concat(value))]);
      } else {
        setTempMobileFilters(tempMobileFilters.filter((e) => e !== value));
      }
    } else {
      if (e.nativeEvent.target.checked) {
        props.setFilters([...new Set(props.filters.concat(value))]);
        setTempMobileFilters([...new Set(tempMobileFilters.concat(value))]);
      } else {
        props.setFilters(props.filters.filter((e) => e !== value));
        setTempMobileFilters(tempMobileFilters.filter((e) => e !== value));
      }
    }
  }

  function renderFilters(collections) {
    return collections.map((collection) => {
      return (
        <label className="filters-checkbox link">
          {collection}
          <input
            type="checkbox"
            name="productFilter"
            value={collection}
            checked={tempMobileFilters.indexOf(collection) !== -1}
            onChange={(e) => {
              onChange(e);
            }}
          />
          <span className="checkmark"></span>
        </label>
      );
    });
  }

  function applyFilters() {
    props.setFilters(tempMobileFilters);
    closeFilters();
  }

  function cancelFilters() {
    setTempMobileFilters(props.filters);
    closeFilters();
  }

  function openFilters() {
    setIsOpen(true);
    props.setIsFiltersDialog(true);
  }

  function closeFilters() {
    setIsOpen(false);
    props.setIsFiltersDialog(false);
  }

  function filtersButtonClick() {
    isOpen ? applyFilters() : openFilters();
  }

  return (
    <div>
      <h3 className="is-desktop tag">
        {t("survey.product_selection.filters")}:
      </h3>
      <button
        aria-expanded={isOpen}
        aria-controls="product-filters"
        className="filters-btn cta cta--secondary link is-mobile"
        onClick={filtersButtonClick}
      >
        <span className="icon-filter"></span>
        <svg
          width="9"
          height="14"
          viewBox="0 0 9 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.99997 8.34682e-07L-2.70446e-05 7L6.99997 14L8.36108 12.6389L2.7222 7L8.36109 1.36111L6.99997 8.34682e-07Z"
            fill="white"
          />
        </svg>
        {t("survey.product_selection.filters")}{" "}
        <span className="filters-btn__counter">({props.filters.length})</span>
      </button>
      <div id="product-filters" className="filters">
        {renderFilters(collections)}
        <div className="filters__button-container is-mobile">
          <Cta
            tagName="button"
            ctaClass="cta--primary cta--centered"
            onClick={applyFilters}
          >
            {t("survey.product_selection.apply")}
          </Cta>
          <Cta
            tagName="button"
            ctaClass="cta--secondary cta--centered"
            onClick={cancelFilters}
          >
            {t("survey.product_selection.cancel")}
          </Cta>
        </div>
      </div>
    </div>
  );
}
